<div class="ipm-common-filter-section">
    <div class="filter-section" [class.set-align-end]="!isShowSearch">
        <div class="ipm-search-wrapper" [class.has-mode-toggle]="showSearchModeToggle" [class.is-magic]="mode === 'magic'" *ngIf="isShowSearch">
            <ng-container *ngIf="mode !== 'magic'; else magicBarTpl">
                <i class="pi pi-search"></i>
                <input type="search"
                    class="form-control"
                    [placeholder]="searchPlaceholder"
                    id="seach" [(ngModel)]="commonService.selectedSearchInputValue"
                    (search)="searchEventTrigger($event, 'search')"
                    (blur)="searchEventTrigger($event, 'search')"
                    autocomplete="off" aria-autocomplete="none"
                    (keyup.enter)="searchEventTrigger($event, 'search')"
                    autocomplete="off" aria-autocomplete="none"
                    [ngModelOptions]="{standalone: true}">
            </ng-container>
            <ng-template #magicBarTpl>
                <ipm-magic-search
                    [compact]="true"
                    [initialPayload]="magicInitialPayload"
                    (searchRequest)="magicSearchRequest.emit($event)"
                    (resetRequest)="magicResetRequest.emit()"
                    (filtersChange)="magicFiltersChange.emit($event)">
                </ipm-magic-search>
            </ng-template>
            <ipm-search-mode-toggle
                *ngIf="showSearchModeToggle"
                [mode]="magicSearchService.searchMode"
                (modeChange)="onSearchModeChange($event)">
            </ipm-search-mode-toggle>
        </div>
        <div class="ipm-toggle-section" *ngIf="isShowLayoutChange">
            <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="ipm-mat-toggle-group" [(ngModel)]="listViewType" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeView($event)" >
                <mat-button-toggle value="list"><i class="pi pi-bars"></i></mat-button-toggle>
                <mat-button-toggle value="grid"><img priority src="./assets/imgs/sub-menu/grid-icon.png" alt="grid-icon" width="16"
                    height="16">
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </div>
    <div class="ipm-magic-attachments mt-1" *ngIf="mode === 'magic' && isShowSearch && (magicHasLyrics || magicAudioName)">
        <div class="media-label" *ngIf="!commonService.isMobileDisableClick">
            <span>Reference Media: </span>
        </div>
        <div class="ipm-magic-attachment-chip ipm-magic-attachment-chip--clickable" *ngIf="magicHasLyrics" (click)="magicSearchService.requestOpenLyricsDialog()">
            <span>Lyrics</span>
            <button type="button" (click)="$event.stopPropagation(); magicSearchService.requestRemoveLyrics()" aria-label="Remove lyrics">✕</button>
        </div>
        <div class="ipm-magic-attachment-chip" *ngIf="magicAudioName">
            <button type="button" class="ipm-magic-attachment-play" (click)="magicSearchService.requestTogglePlayback()" [attr.aria-label]="isAudioPlaying ? 'Pause' : 'Play'">
                <i class="fa fa-play" *ngIf="!isAudioPlaying"></i>
                <i class="fas fa-pause" *ngIf="isAudioPlaying"></i>
            </button>
            <span>{{ magicAudioName }}</span>
            <button type="button" (click)="magicSearchService.requestRemoveAudio()">✕</button>
        </div>
    </div>
    <div class="filter-option-section" *ngIf="isShowFilterOptions" [appNavbarChangeClass]="stickyOnScroll" id="filter-section" [class.set-margin]="isComponentType === 'playlist' && !commonService.isSetFilterPositionFixed">
        <div class="ipm-filter-body">
            <div class="ipm-filter-mob-button">
                <!-- Horizontal scrollable list of filter buttons — each opens the popup pre-selected on that filter's tab -->
                <div class="ipm-mob-filter-scroll">
                    <ng-container *ngFor="let filterOption of resolvedFilterOptionList; let i = index">
                        <ng-container *ngIf="filterOption?.filter_type !== 'swipes-menu' && filterOption?.filter_type !== 'swipes-menu-bpm-offer'">
                            <button class="btn filter-button"
                                [class.filter-button--active]="(filterOption?.filter_type === 'menu' ? filterOption?.isFilterApplied : (filterOption?.filter_selected_values?.length ?? 0) > 0)"
                                (click)="openMobileFilterAtTab(getMobileTabIndex(i))">
                                <span>{{ filterOption?.filter_label_name }}</span>
                                <i class="pi pi-chevron-down"></i>
                            </button>
                        </ng-container>
                    </ng-container>
                </div>
            </div>
            <div class="ipm-desktop">
                <div class="filter-label">Filters:</div>
                <ng-container *ngFor="let filterOption of resolvedFilterOptionList; let  i = index;">
                    <ng-container *ngIf="filterOption?.filter_type === 'multiselect'; else menuOptions">
                        <ng-container *ngIf="isComponentType === 'playlist' &&  filterOption.ApiFilterKey !== 'categories'">
                            <p-multiSelect [id]="filterOption.filter_id"
                            [options]="(filterOption?.filter_sub_list ? ((filterOption?.filter_sub_list || [] ) | filterListSepration : geneFilterList : filterOption.ApiFilterKey : 'playlist') : [])"
                            [defaultLabel]="filterOption?.filter_label_name"
                            [(ngModel)]="filterOption.filter_selected_values"
                            optionLabel="value"
                            [filter]="true"
                            [autofocus]="false"
                            [autofocusFilter]="false"
                            [autoOptionFocus]="false" [focusOnHover]="false"
                            [className]="'ipm-multiselect'"
                            [showTransitionOptions]="'0ms'"
                            [hideTransitionOptions]="'0ms'"
                            #multiSelect
                            (onChange)="searchEventTrigger($event, 'filter')">
                            <ng-template let-selectedFilterObj pTemplate="selectedItems">
                                    <div>
                                        {{filterOption?.filter_label_name}}
                                    </div>
                            </ng-template>
                            <ng-template let-filterObj pTemplate="item">
                                <div class="d-flex align-items-center gap-2">
                                    <span>
                                        {{ filterObj.value }}
                                    </span>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        </ng-container>
                        <ng-container *ngIf="isComponentType !== 'playlist'">
                            <p-multiSelect [id]="filterOption.filter_id"
                            [options]="filterOption?.filter_sub_list"
                            [defaultLabel]="filterOption?.filter_label_name"
                            [(ngModel)]="filterOption.filter_selected_values"
                            optionLabel="value"
                            [filter]="true"
                            [autofocus]="false"
                            [autofocusFilter]="false"
                            [className]="'ipm-multiselect'"
                            [showTransitionOptions]="'0ms'"
                            [hideTransitionOptions]="'0ms'"
                            #multiSelect
                            (onChange)="searchEventTrigger($event, 'filter')">
                        <ng-template let-selectedFilterObj pTemplate="selectedItems">
                                <div>
                                    {{filterOption?.filter_label_name}}
                                </div>
                        </ng-template>
                        <ng-template let-filterObj pTemplate="item">
                            <div class="d-flex align-items-center gap-2">
                                <span>
                                    {{ filterObj.value }}
                                </span>
                            </div>
                        </ng-template>
                    </p-multiSelect>
                        </ng-container>
                    </ng-container>
                    <ng-template #menuOptions>
                        <ng-container *ngIf="isComponentType === 'playlist' &&  filterOption.ApiFilterKey !== 'price' ">
                            <ng-container *ngIf="filterOption?.filter_type !== 'swipes-menu' && filterOption?.filter_type !== 'sort_menu' && filterOption?.filter_type !== 'swipes-menu-bpm-offer'">
                                <button class="btn ipm-filter-btn" [matMenuTriggerFor]="menuItem"  [matMenuTriggerData]="{filterData: filterOption}" id="filterOption?.filter_label_name" role="button" tabindex="0" aria-label="Open user menu">
                                    <span class="ipm-text">{{filterOption?.filter_label_name}}</span>
                                    <span class="ipm-icon"><i class="pi pi-chevron-down"></i></span>
                                </button>
                            </ng-container>
                        </ng-container>
                        <ng-container *ngIf="isComponentType !== 'playlist'">
                            <ng-container *ngIf="filterOption?.filter_type !== 'swipes-menu' && filterOption?.filter_type !== 'sort_menu' &&   filterOption?.filter_type !== 'swipes-menu-bpm-offer'">
                                <button class="btn ipm-filter-btn" [matMenuTriggerFor]="menuItem"  [matMenuTriggerData]="{filterData: filterOption}" id="filterOption?.filter_label_name" role="button" tabindex="0" aria-label="Open user menu">
                                    <span class="ipm-text">{{filterOption?.filter_label_name}}</span>
                                    <span class="ipm-icon"><i class="pi pi-chevron-down"></i></span>
                                </button>
                            </ng-container>
                        </ng-container>
                    </ng-template>
                </ng-container>
                <ng-container *ngIf="mode === 'magic'">
                    <button class="btn ipm-filter-btn" [matMenuTriggerFor]="stemEqMenu" type="button">
                        <span class="ipm-text">{{ eqEnabled && stemActiveCount > 0 ? 'Stems Eq (' + stemActiveCount + ')' : 'Stems EQ' }}</span>
                        <span class="ipm-icon"><i class="pi pi-chevron-down"></i></span>
                    </button>
                    <mat-menu #stemEqMenu="matMenu" [class]="'ipm-chip-filter-menu-panel'">
                        <div class="ipm-chip-filter-panel ipm-chip-filter-panel--stem" (click)="$event.stopPropagation()">
                            <ipm-magic-search-stem-eq
                                [stems]="stems"
                                (stemsChange)="onStemsChange($any($event))"
                                [eqEnabled]="eqEnabled"
                                (eqEnabledChange)="onEqEnabledChange($any($event))">
                            </ipm-magic-search-stem-eq>
                        </div>
                    </mat-menu>
                </ng-container>
            </div>
            <div class="sort-section" *ngIf="isShowSort && mode !== 'magic'">
                <p-dropdown [options]="stortingList" [(ngModel)]="selectedSort" optionLabel="name"  (onChange)="onChangeSort($event)"></p-dropdown>
            </div>
            <div class="ipm-toggle-section">
                <mat-button-toggle-group name="fontStyle" aria-label="Font Style" class="ipm-mat-toggle-group" [(ngModel)]="listViewType" [ngModelOptions]="{standalone: true}" (ngModelChange)="onChangeView($event)"  *ngIf="isShowLayoutChange">
                    <mat-button-toggle value="list"><i class="pi pi-bars"></i></mat-button-toggle>
                    <mat-button-toggle value="grid"><img priority src="./assets/imgs/sub-menu/grid-icon.png" alt="grid-icon" width="16"
                        height="16">
                    </mat-button-toggle>
                </mat-button-toggle-group>
            </div>
        </div>
    </div>
    <div class="tag-list-section" *ngIf="isShowFilterOptions && shouldShowSelectedFilterSection">
        <p-tag class="ipm-custom-tags" *ngIf="commonService.selectedSearchInputValue && isShowSearchSection && mode !== 'magic'">
            <div class="d-flex align-items-center gap-2 ipm-tags-list" >
                <span class="text-base ipm-heading">{{commonService.selectedSearchType.label}}:</span>
                <span class="ipm-value">{{commonService.selectedSearchInputValue}}</span>
                <i class="pi pi-times text-xs ipm-close" (click)="isRemoveFilter('search')"></i>
            </div>
        </p-tag>
        <ng-container *ngFor="let filterOptions of resolvedFilterOptionList; let i = index;">
            <ng-container  *ngIf="filterOptions?.filter_type === 'multiselect'">
                <ng-container *ngIf="filterOptions.filter_selected_values.length > 0">
                    <p-tag class="ipm-custom-tags">
                        <div class="d-flex align-items-center gap-2 ipm-tags-list"
                        pTooltip="{{filterOptions.filter_selected_values | getTooltipPlusValue}}"
                        tooltipStyleClass="ipm-custom-tooltip"
                        [appendTo]="multipleToolTip" #multipleToolTip tooltipPosition="top">
                            <span class="text-base ipm-heading">
                                {{filterOptions?.filter_label_name}}:
                            </span>
                            <span class="ipm-value">
                                {{filterOptions .filter_selected_values[0].value}}
                                <ng-container *ngIf="filterOptions.filter_selected_values.length > 1">
                                    ,+{{filterOptions.filter_selected_values.length - 1}}
                                </ng-container>
                            </span>
                            <i class="pi pi-times text-xs ipm-close" (click)="isRemoveFilter('filter', i)"></i>
                        </div>
                    </p-tag>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="filterOptions?.filter_type === 'menu'">
                <ng-container *ngIf="(filterOptions.filter_sub_list[0].starting_range && filterOptions.filter_sub_list[0].end_range) && filterOptions.isFilterApplied">
                <p-tag class="ipm-custom-tags">
                    <div class="d-flex align-items-center gap-2 ipm-tags-list" >
                        <span class="text-base ipm-heading">
                            {{filterOptions?.filter_label_name}}:
                        </span>
                        <span class="ipm-value">
                            <ng-container *ngIf="filterOptions.ApiFilterKey === 'price'">₹</ng-container>{{filterOptions.filter_sub_list[0].starting_range}}
                            <span>To</span>
                            <ng-container *ngIf="filterOptions.ApiFilterKey === 'price'"> ₹</ng-container>{{filterOptions.filter_sub_list[0].end_range}}
                        </span>
                        <i class="pi pi-times text-xs ipm-close" (click)="isRemoveFilter('filter', i)"></i>
                    </div>
                </p-tag>
            </ng-container>
            </ng-container>
            <ng-container *ngIf="filterOptions?.filter_type === 'swipes-menu' || filterOptions?.filter_type === 'swipes-menu-bpm-offer'">
                <ng-container *ngFor="let swiperOption of filterOptions.filter_sub_list; let j = index;">
                    <ng-container *ngIf="swiperOption.isSelected">
                        <p-tag class="ipm-custom-tags">
                            <div class="d-flex align-items-center gap-2 ipm-tags-list" >
                                <span class="text-base ipm-heading" *ngIf="swiperOption?.filter_label_name">
                                    {{swiperOption?.filter_label_name}}:
                                </span>
                                <span class="ipm-value">
                                    {{swiperOption?.value}}
                                </span>
                                <i class="pi pi-times text-xs ipm-close" (click)="isRemoveFilter('filter', i, j)"></i>
                            </div>
                        </p-tag>
                    </ng-container>
            </ng-container>
            </ng-container>
        </ng-container>
        <a href="javascript:void(0)" class="ipm-clear-filter" (click)="clearAllFilter()">Clear Filter</a>
    </div>
</div>

<ipm-common-beats-dialog (onTriggerSort)="sortingEventTrigger($event)" [isComponentType]="isComponentType" [genereFilter]="geneFilterList"></ipm-common-beats-dialog>

<mat-menu #menuItem="matMenu" [class]="'ipm-chip-filter-menu-panel'" >
    <ng-template matMenuContent let-filterData="filterData">
        <div class="ipm-chip-filter-panel ipm-chip-filter-panel--range" (click)="$event.stopPropagation()">
            <label class="ipm-chip-filter-label">{{filterData?.filter_label_name}}</label>
            <p-slider
                [ngModel]="getMenuRangeValues(filterData)"
                (ngModelChange)="onMenuRangeChange(filterData, $event)"
                [ngModelOptions]="{standalone: true}"
                [range]="true"
                [min]="0"
                [max]="getMenuRangeMax(filterData)"
                [step]="filterData?.ApiFilterKey === 'price' ? 500 : 1"
                (onSlideEnd)="onChangeValue($event)">
            </p-slider>
            <div class="ipm-input-range mt-3">
                <div class="ipm-input-range__field">
                    <span class="ipm-icon-color" *ngIf="filterData?.ApiFilterKey === 'price'">₹</span>
                    <input type="text"
                    placeholder="Min"
                    (click)="$event.stopPropagation()"
                    (keypress)="formService.keyPressNumber($event)"
                    id="starting_range_{{filterData?.ApiFilterKey}}"
                    [(ngModel)]="filterData.filter_sub_list[0].starting_range"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onChangeValue($event)">
                </div>
                <span class="ipm-input-range__sep">–</span>
                <div class="ipm-input-range__field">
                    <span class="ipm-icon-color" *ngIf="filterData?.ApiFilterKey === 'price'">₹</span>
                    <input type="text"
                    placeholder="Max"
                    (click)="$event.stopPropagation()"
                    (keypress)="formService.keyPressNumber($event)"
                    id="end_range_{{filterData?.ApiFilterKey}}"
                    [(ngModel)]="filterData.filter_sub_list[0].end_range"
                    [ngModelOptions]="{standalone: true}"
                    (ngModelChange)="onChangeValue($event)">
                </div>
            </div>
            <div class="ipm-price-type-selector" *ngIf="filterData?.ApiFilterKey === 'price' && mode !== 'magic'">
                <mat-radio-group
                    class="ipm-price-type-radio-group"
                    [ngModel]="filterData.selectedPriceType || 'wav'"
                    (ngModelChange)="onPriceTypeChange(filterData, $event)"
                    [ngModelOptions]="{standalone: true}">
                    <mat-radio-button
                        *ngFor="let opt of priceTypeOptions"
                        class="ipm-price-type-radio"
                        [value]="opt.key">
                        {{opt.label}}
                    </mat-radio-button>
                </mat-radio-group>
            </div>
        </div>
    </ng-template>
  </mat-menu>
